<script>
import signBtn from '../ui/signBtn.vue';
import registrationBtn from '../ui/registrationBtn.vue';
import headerTop from '../blocks/heaer-top.vue';
export default {
    name: 'headerMain',
    components: {
        signBtn,
        registrationBtn,
        headerTop
    },
    data() {
        return {
            hovered: false,
        };
    },
    methods: {

    }
}
</script>

<template>

    <div class="header">
        <headerTop />
        <div class="container">
            <div class="header__content">
                <div class="header__left">
                    <a class="header__logo desk" ><img src="@/assets/image/logoMain.svg" alt=""></a>
                    <a  class="header__logo mob"><img src="@/assets/image/logoMain-mob.svg" alt=""></a>
                    <nav class="header__nav">
                        <ul class="header__nav-list">
                            <li class="header__nav-item"><router-link class="header__nav-link"
                                    to="">Главная</router-link></li>
                            <li class="header__nav-item"><router-link class="header__nav-link" to="">О
                                    компании</router-link></li>
                            <li class="header__nav-item" @mouseover="hovered = true" @mouseleave="hovered = false">
                                <router-link class="header__nav-link" to="">
                                    Услуги
                                    <img :src="hovered ? require('@/assets/image/arrow-down.svg') : require('@/assets/image/arrow-downBlack.svg')"
                                        alt="">
                                </router-link>
                            </li>
                            <li class="header__nav-item"><router-link class="header__nav-link" to="">Наши
                                    вакансии</router-link></li>
                        </ul>
                    </nav>
                    <div class="header__wrapper-links-wrapp">
                        <div class="header__wrapper-links">
                            <a class="header__wrapper-link"><img src="../../assets/image/call-addBlack.svg" alt="">
                                <div><span>8(800)</span> 555 66 80</div>
                            </a>
                            <a class="support-link" >Круглосуточная поддержка</a>
                        </div>
                        <div class="header__wrapper-links">
                            <a class="header__wrapper-link"><img src="../../assets/image/sms-trackingBlack.svg" alt="">
                                <div><span>info@</span>hrsetka.ru</div>
                            </a>
                            <a class="support-link" >Круглосуточная поддержка</a>
                        </div>
                    </div>
                </div>
                <div class="header__right">
                    <registrationBtn />
                    <signBtn :link="'/login?l=true'" class="header__sign" />
                    <router-link class="btn-login" :to="'/login?l=true'">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.4">
                                <path d="M9.73438 12.1837L11.8677 10.0503L9.73438 7.91699" stroke="#1A1A1A"
                                    stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M3.33398 10.0498H11.809" stroke="#1A1A1A" stroke-width="2"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <path
                                d="M10 3.33301C13.6833 3.33301 16.6667 5.83301 16.6667 9.99967C16.6667 14.1663 13.6833 16.6663 10 16.6663"
                                stroke="#1A1A1A" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </router-link>
                    <div class="btn-menu">
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>
.header__sign {
    background: #1A1A1A;

}

.header__wrapper-links-wrapp {
    display: flex;
    gap: 35px;
}

.header__wrapper-link {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}



.support-link {
    color: #80879C;
    font-family: Aeroport;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    text-decoration-line: underline;
}

.header__wrapper-link span {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
}

.header__wrapper-links {
    display: flex;
    flex-direction: column;
    gap: 4px;
}



.header__content {
    display: flex;
    justify-content: space-between;
}

.header__nav-link {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    gap: 13px;
    align-items: center;
}



.header__nav-list {
    display: flex;
    border-radius: 43px;
    background: #E7ECEE;
}

.header__nav-item {
    padding: 19px 40px;
    transition: background .3s linear;
    border-radius: 43px;
    background: transparent;
}

.header__nav-item:hover {
    background: #1A1A1A;
    transition: background .3s linear;
}

.header__nav-item:hover .header__nav-link {
    color: white;
}

.header__left {
    display: flex;
    align-items: center;
    gap: 35px;
}

.header__right {
    display: flex;
    gap: 10px;
}

.btn-login {
    display: none;
    padding: 9px;
    background: #E7ECEE;
    border-radius: 10px;
    width: 38px;
    height: 38px;
}

.btn-menu {
    padding: 16px 12px;
    width: 38px;
    height: 38px;
    display: none;
    flex-direction: column;
    align-items: center;
    background: #E7ECEE;
    border-radius: 10px;
    gap: 2px;
}
.btn-menu span {
    width: 14px;
    height: 2px;
    background: #141414;
}

.header__logo.mob {
    display: none;
}

@media (max-width: 1600px) {
    .header__nav-item {
        padding: 16px 20px;
    }

    .header__left {
        gap: 15px;
    }

    .header__wrapper-links-wrapp {
        gap: 15px;
    }
}

@media (max-width: 1440px) {
    .header__wrapper-links-wrapp {
        display: none;
    }
}

@media screen and (max-width: 991px) {
    .header {
        padding-top: 20px;
    }
    .header__nav {
        display: none;
    }
    .registration-button {
        display: none;
    }
    .header__sign {
        display: none;
    }
    .header__right {
        align-items: center;
    }
    .btn-login {
        display: block;
    }
    .btn-menu {
        display: flex;
    }
    .header__logo.mob {
        display: block;
    }
    .header__logo.desk {
        display: none;
    }
    .header {
        margin-bottom: -20px;
    }
}
@media screen and (max-width: 650px) {

}
</style>